export default __webpack_public_path__ + "static/media/like-minded-community.c209c286.png";